import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ConditionalComponent } from '@components/functionComponent';
import { EmptyStateImage } from '@assets/images';

export default function NoData({ title, desc, noData, ...props }) {
    return (
        <ConditionalComponent statement={noData}>
            <Flex justifyContent={'center'} alignItems={'center'} flexDir={'column'} w={'full'} minH={'300px'}>
                <EmptyStateImage />
                <Text fontWeight={'700'} fontSize={'20px'} mb={'4px'}>
                    {title}
                </Text>
                <Text fontSize={'14px'}>{desc}</Text>
            </Flex>
        </ConditionalComponent>
    );
}
